import { IconPrefix } from '@components/primitives/Icon/IconPrefix'
import { Text } from '@components/primitives/Text'
import { faBarsProgress } from '@fortawesome/pro-solid-svg-icons/faBarsProgress'
import { faCapsules } from '@fortawesome/pro-solid-svg-icons/faCapsules'
import { faHospitalUser } from '@fortawesome/pro-solid-svg-icons/faHospitalUser'
import type { TextColor } from '@lib/colors/colors'
import { MINDMED_GAD_PHASE_3_SISTER_TRIAL } from '@modules/trials/constants/trials'
import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import { getPhaseFromPhaseList } from '@modules/trials/helpers/getPhaseFromPhaseList'
import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'

export const TreatmentClass = ({
  color = 'text-white',
  trial,
}: {
  color?: TextColor
  trial: Pick<ClinicalTrialForListingPage, 'nctId' | 'treatments'>
}) => {
  // Sponsor request
  if (trial.nctId === MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId) {
    return null
  }

  const [primaryTreatment] = trial.treatments.filter((t) => t.isPrimary)
  const treatmentString = primaryTreatment?.class
    ? `${primaryTreatment.class}`
    : undefined

  if (!treatmentString) return null
  return (
    <Text
      className={color}
      styleName='p-small'
      value={<IconPrefix icon={faCapsules}>{treatmentString}</IconPrefix>}
    />
  )
}

export const PhaseStatus = ({ trial }: { trial: TrialAssociation }) => {
  const phase = getPhaseFromPhaseList(trial.phaseList)

  return (
    <Text
      className='text-white'
      styleName='p-small'
      value={<IconPrefix icon={faBarsProgress}>{phase}</IconPrefix>}
    />
  )
}

export const RecruitingStatus = ({ trial }: { trial: TrialAssociation }) => {
  return (
    <Text
      className='text-white'
      styleName='p-small'
      value={
        <IconPrefix icon={faHospitalUser}>
          {trial.overallStatus === 'Recruiting'
            ? 'Recruiting'
            : 'Waitlist Available'}
        </IconPrefix>
      }
    />
  )
}
